<template>
  <div v-if="show" class="page page-current">
    <div class="header">
      <p class="icon icon_flag7"><img :src="details.icon_flag" alt="">退款</p>
      <h2>-{{ details.refund_amount }}</h2>
      <span>已退款</span>
    </div>
    <div class="content-padded">
      <ul>
        <li><span>订单编号</span><span>{{ details.order_number }}</span></li>
        <li><span>退款金额</span><span>{{ details.refund_amount }}</span></li>
        <li>
          <span>退款类型</span>
          <dl>
            <dd
              v-for="item in details.process"
              :key="item.status"
              style="font-size:0.75rem;font-family: initial;">
              {{ item.status }}  {{ item.time }}
            </dd>
          </dl>

        </li>
        <li><span>退款进度</span><span>{{ details.refund_status }}</span></li>
        <li><span>退款员工</span><span>{{ details.staff || '门店二维码' }}</span></li>
        <li><span>退款备注</span><span>{{ details.remarks }}</span></li>
      </ul>
    </div>
    <div :style="{padding:'10px',fontSize:'14px'}"><a :style="{color:'#171B63',borderBottom:'1px solid #171B63'}" @click="handleGo(details.order_number)">查看收款订单</a></div>
  </div>
</template>

<script>
import { getRefundDetail } from '@/api/order'
export default {
  data() {
    return {
      num: this.$route.query.num,
      details: '',
      icon: '',
      type: '',
      show: false
    }
  },
  created() {
    this.handleDocumentInit()
  },
  methods: {
    handleDocumentInit() {
      this.show = false
      // eslint-disable-next-line
      $.showIndicator()
      getRefundDetail(this.num).then(res => {
        this.details = res.data
        this.icon = res.data.icon_flag
        this.type = res.data.type
        // eslint-disable-next-line
        $.hideIndicator()
        this.show = true
      }).catch(res => {
        // eslint-disable-next-line
        $.hideIndicator()
        this.show = true
      })
    },
    handleGo(v) {
      this.$router.push({ name: 'order', query: { 'num': v }})
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/styles/order.less';
</style>
